import React from 'react';

import * as styles from './PayoutsTable.module.css';
import {Pill} from 'ui-kit';

const moneyFormat = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
}).format;
const dateFormat = new Intl.DateTimeFormat('en-US', {
  month: 'long',
  day: 'numeric',
  year: 'numeric',
  timeZone: 'UTC',
}).format;

export function PayoutsTable({payouts}) {
  return (
    <table className={styles.Table}>
      <thead>
        <tr>
          <th className={styles.HeadCell}>Payout date</th>
          <th className={styles.HeadCell}>Amount</th>
          <th className={styles.HeadCell}>Status</th>
        </tr>
      </thead>
      <tbody>
        {payouts.map(({id, amount, status, arrivalDate}) => (
          <tr key={id} className={styles.Row}>
            <td className={styles.Cell}>{dateFormat(new Date(arrivalDate))}</td>
            <td className={styles.Cell}>{moneyFormat(amount / 100)}</td>
            <td className={styles.Cell}>
              {status === 'PAID' ? (
                <Pill color="green">Paid</Pill>
              ) : status === 'CANCELED' ? (
                <Pill color="red">Canceled</Pill>
              ) : status === 'FAILED' ? (
                <Pill color="red">Failed</Pill>
              ) : status === 'PENDING' ? (
                <Pill>Pending</Pill>
              ) : status === 'IN_TRANSIT' ? (
                <Pill color="purple">In transit</Pill>
              ) : null}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
